module.exports = __webpack_public_path__ + "static/media/gmail-recipient-correct.7df2a1e3.png";